import React, { FC } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

interface IProps {
  title: string;
  amount: number;
}

const BalanceCard: FC<IProps> = ({ title, amount }) => {
  return (
    <Box
      flex="1"
      mb="10px"
      borderRadius="10px"
      p="15px"
      bg="green.500"
      color="white"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Box>
          <Text
            fontSize="11px"
            color="green.50"
            fontWeight="bold"
            mb="2px"
          >
            Saldo
          </Text>
          <Text
            fontSize="18px"
            color="white"
            fontWeight="400"
          >
            {title}
          </Text>
        </Box>
        <Text
          fontSize="16px"
          color="white"
          fontWeight="500"
        >
          {amount}
        </Text>
      </Flex>
    </Box>
  );
};

export { BalanceCard }; 